import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Get_M_Asset_GeoTagging_SelectDataAPI } from "../../../../../Redux/MainCountSlice/GardenMainCount";
import MapView2 from "../../../../../Components/MapView/MapView2";
import MapView4 from "../../../../../Components/MapView/MapView4";
import { useAuthState } from "../../../../../Helper/Context";
import { toastErrorr } from "../../../../../Helper/ToastMessage";
import { Loading } from "../../../../../Helper/Loading";



export default function GardenMasterCard({ BgColor, count, title, navLink, cardName, masterCard, color, imgPath, handleAsset, M_AssetTypeID }) {
    const navigate = useNavigate()
    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()



    const handleGardenMasterCard = () => {
        navigate(navLink)
    }

    const [ShowMap, setShowMap] = React.useState({
        show: false,
        data: ''
    })

    const [LocationData, setLocationData] = React.useState({})
    const [loader, setloader] = React.useState(false)

    const handleLocation = () => {
        const data = {
            M_GD_SectorID: 0,
            M_UsersID: UserID,
            token: token,
            From: 1,
            To: 9000,
            M_AssetTypeID: M_AssetTypeID,
            M_WardID: Ward.ID,
            M_AssetID: 0,
            handleResponse: handleResponse
        }
        dispatch(Get_M_Asset_GeoTagging_SelectDataAPI({ data }))
    }

    const handleResponse = (value) => {
        setLocationData(value)
        handleAllGardenLocation(value)
    }

    let AllDataMap = [];
    let showError = (item => item.assetLatitude == null && item.assetLongitude == null) ? true : false;
    let showMessage = false

    const handleAllGardenLocation = (data) => {
        setloader(true);
        if (data) {
            data.forEach(item => {
                if (item.assetLatitude != null && item.assetLongitude != null) {
                    AllDataMap = [...AllDataMap, item];
                    setTimeout(() => {
                        setShowMap({
                            show: true,
                            data: AllDataMap
                        });
                        if (!showMessage) {
                            showMessage = true
                        }
                    }, 1000);
                }
                // else {
                //     if (AllDataMap.length == 0) {
                //         toastErrorr('Location not found')
                //         showError = true;
                //     }
                // }
            });
            if (AllDataMap.length == 0) {
                toastErrorr('Location not found')
                showError = true;
            }
        }
        else {
            if (AllDataMap.length == 0) {
                toastErrorr('Location not found')
                showError = true;
            }
        }
        setTimeout(() => {
            setloader(false);
        }, 1000);
    }

    const handleCloseMap = () => {
        setShowMap({
            show: false,
            data: ''
        });
    }

    return (
        <>
            {loader && <Loading />}
            <div className="cards  p-2 mb-1 br-10" style={{ cursor: 'pointer' }} >

                {/* <div className={masterCard}>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <h4 className={color === 'red' ? "fw-normal text-red" : "fw-normal text-blue"}><b>{count}</b></h4>
                    </div>
                    <h4 className={color === 'red' ? "fw-normal text-red ImgBg mt-0 bg-red-light" : "fw-normal text-blue ImgBg mt-0 bg-blue-light"}>
                        <img style={{ width: "25px", height: '25px' }} src={imgPath} alt="" />
                    </h4>
                </div>
            </div> */}
                <div className={` row p-3 ${BgColor} `}>

                    <button type="button" className="btn position-relative mt-n2 d-flex float-end "
                        onClick={() => handleLocation()}>
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-white p-2">
                            <img src="../assets/img/googlemaps.png" style={{ width: '25px' }} />
                        </span>
                    </button>

                    <div className="row" onClick={() => handleAsset(title)} >
                        <div className="col-9 pt-1">
                            <p className="mb-0 master_text mb-0 pb-0">
                                <b>{title}</b>
                            </p>
                        </div>
                        <div className="row col-3 text-end text-white pb-0 mb-0 mt-n1">
                            <p className="fs-4 mb-0 pb-0">
                                <b>{count} </b>
                            </p>
                        </div>
                    </div>

                </div>
            </div>

            {
                ShowMap.show ?
                    <MapView4
                        LocationData={ShowMap?.data}
                        ShowMap={ShowMap}
                        handleCloseMap={handleCloseMap}
                        currEmployeeName=''
                    />
                    : ''
            }
        </>
    )
}